var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useDataProvider, useNotify, useTranslate } from 'react-admin';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, MenuItem } from '@mui/material';
var CreateTrialAccountButton = function () {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState({
        username: '',
        email: '',
        password: '',
        Last_name: '',
        First_name: '',
        gender: '',
        organizationName: '',
        trialDay: 0,
        quota: 0
    }), formData = _b[0], setFormData = _b[1];
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var translate = useTranslate();
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dataProvider.createTrialUser({
                            data: formData
                        })];
                case 1:
                    _a.sent();
                    notify(translate('trialAccount.success'), { type: 'success' });
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    notify(translate('trialAccount.error'), { type: 'error' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", onClick: handleClickOpen, sx: {
                    background: '#1561a5',
                    '&:hover': {
                        backgroundColor: '#1976d2'
                    },
                    boxShadow: '0 4px 6px rgba(21, 97, 165, 0.2)',
                    padding: '8px 24px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: 'white',
                    textTransform: 'none',
                    minHeight: '48px',
                    '&.Mui-selected': {
                        color: 'white',
                    }
                }, children: translate('trialAccount.createButton') }), _jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: "sm", fullWidth: true, PaperProps: {
                    sx: {
                        borderRadius: '16px',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                    }
                }, children: [_jsx(DialogTitle, { sx: {
                            backgroundColor: '#1561a5',
                            color: 'white',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px'
                        }, children: translate('trialAccount.createButton') }), _jsx(DialogContent, { children: _jsxs(Grid, { container: true, spacing: 1.5, sx: { mt: 1 }, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, label: translate('trialAccount.username'), name: "username", value: formData.username, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, label: translate('trialAccount.email'), name: "email", type: "email", value: formData.email, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, label: translate('trialAccount.password'), name: "password", type: "password", value: formData.password, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(TextField, { variant: "outlined", fullWidth: true, label: translate('trialAccount.firstName'), name: "First_name", value: formData.First_name, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(TextField, { variant: "outlined", fullWidth: true, label: translate('trialAccount.lastName'), name: "Last_name", value: formData.Last_name, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(TextField, { variant: "outlined", fullWidth: true, select: true, label: translate('trialAccount.gender'), name: "gender", value: formData.gender, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } }, children: [_jsx(MenuItem, { value: "M", children: translate('trialAccount.male') }), _jsx(MenuItem, { value: "F", children: translate('trialAccount.female') }), _jsx(MenuItem, { value: "other", children: translate('trialAccount.other') })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { variant: "outlined", fullWidth: true, label: translate('trialAccount.organizationName'), name: "organizationName", value: formData.organizationName, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, label: translate('trialAccount.trialDays'), name: "trialDay", type: "number", value: formData.trialDay, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, label: translate('trialAccount.quota'), name: "quota", type: "number", value: formData.quota, onChange: handleChange, sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', border: 'black' } } }) })] }) }), _jsxs(DialogActions, { sx: { padding: '16px 24px' }, children: [_jsx(Button, { onClick: handleClose, sx: {
                                    borderRadius: '8px',
                                    padding: '6px 16px'
                                }, children: translate('trialAccount.cancel') }), _jsx(Button, { onClick: handleSubmit, variant: "contained", sx: {
                                    backgroundColor: '#1561a5',
                                    borderRadius: '8px',
                                    padding: '6px 16px',
                                    '&:hover': {
                                        backgroundColor: '#1976d2'
                                    }
                                }, children: translate('trialAccount.create') })] })] })] }));
};
export default CreateTrialAccountButton;
